import { configureStore } from "@reduxjs/toolkit";

import authService from "./services/authService";
import openAiService from "./services/openAiService";
import userService from "./services/userService";

import authReducer from "./reducers/authReducer";
import globalReducer from "./reducers/globalReducer";

const Store = configureStore({
  reducer: {
    [authService.reducerPath]: authService.reducer,
    [openAiService.reducerPath]: openAiService.reducer,
    [userService.reducerPath]: userService.reducer,

    authReducer: authReducer,
    globalReducer: globalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      openAiService.middleware,
      userService.middleware,
    ]),
});

export default Store;
